import(/* webpackMode: "eager" */ "/vercel/path0/app/(front)/contact/page.tsx");
